import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { css } from 'emotion';
import CreateContractsCard from './CreateContractsCard';
import InvestigateSkusCard from './InvestigateSkusCard';
import SettingsCard from './SettingsCard';
import RecentlyCreatedContractsCard from './RecentlyCreatedContractsCard';
import { platinum, slate } from '@cimpress/react-components/lib/colors';
import { actions as termActions, selectors as termSelectors } from '../../../reducers/terms';
import { selectors as identitySelectors } from '../../../reducers/identities';
import { auth } from '../../../utils/auth';
import StatCard from './StatCard';
import TermStatus, { DisplayTermStatus } from '../../../constants/termStatus';
import { history } from '../../../utils/history';

const borderStyle = css({
  borderBottom: `2px solid ${platinum}`,
  paddingBottom: '20px',
  marginBottom: '20px'
});

const reportGridStyle = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
  gridGap: '15px'
});

const cardsGridStyle = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(275px, 1fr))',
  gridGap: '15px',
  marginBottom: '30px',
  '.cardText': {
    marginBottom: '15px'
  },
  '.card-minimal > .card-header::after': {
    display: 'none'
  },
  '.card-minimal .card-header': {
    fontSize: '1.2em'
  }
});

function LandingPage(props) {
  const { terms } = props;
  const { t } = useTranslation();
  const profile = auth.getProfile();

  const goToAllContracts = () => {
    history.push({ pathname: '/contracts' });
  };

  const goToPendingContracts = () => {
    history.push({
      pathname: '/contracts',
      state: { cardFilter: DisplayTermStatus.PENDING_APPROVAL }
    });
  };

  const goToNeedsApprovalContracts = () => {
    history.push({
      pathname: '/contracts',
      state: { cardFilter: DisplayTermStatus.AWAITING_YOUR_RESPONSE }
    });
  };

  useEffect(() => {
    props.fetchTermsForHomePage();
  }, []);

  const needApprovalTermsCount = terms.filter(
    term => term.status === TermStatus.PENDING && term.userHasAuthorizationFor.acceptor
  ).length;
  const pendingTermsCount = terms.filter(
    term => term.status === TermStatus.PENDING && !term.userHasAuthorizationFor.acceptor
  ).length;

  return (
    <div className="container">
      <div>
        {' '}
        <div style={{ textAlign: 'center', marginBottom: '10px' }}>
          <h2>
            {profile && profile['given_name'] && t('landingPage:nameGreeting', { name: profile['given_name'] })}
            {t('landingPage:welcome')}
          </h2>
          <div style={{ fontSize: 'medium', color: slate }}>{t('landingPage:setupContracts')}</div>
        </div>
        <div style={{ margin: '30px 75px 0px 75px' }}>
          <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>{t('landingPage:todaysReport')}</h5>
          <div className={reportGridStyle}>
            <StatCard
              title={t('common:commonWords.contracts')}
              label={t('landingPage:statCardTotalLabel')}
              onClick={goToAllContracts}
              value={terms.length}
            />
            <StatCard
              title={t('common:contractStatus:needsApproval')}
              label={t('landingPage:statCardTotalLabel')}
              onClick={goToNeedsApprovalContracts}
              value={needApprovalTermsCount}
            />
            <StatCard
              title={t('common:contractStatus:pending')}
              label={t('landingPage:statCardTotalLabel')}
              onClick={goToPendingContracts}
              value={pendingTermsCount}
            />
          </div>
          <div style={{ display: 'flex' }} />
        </div>
        <div className={borderStyle} />
        <div className={cardsGridStyle}>
          <CreateContractsCard terms={terms} />
          <InvestigateSkusCard />
          <SettingsCard />
          <RecentlyCreatedContractsCard terms={terms} numberToDisplay={4} />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  terms: termSelectors.getTermsForHomePage(state),
  hasFulfillerIdentities: identitySelectors.getHasFulfillerIdentities(state),
  hasMerchantIdentities: identitySelectors.getHasMerchantIdentities(state)
});

const mapDispatchToProps = {
  fetchTermsForHomePage: termActions.fetchTermsForHomePageV2
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingPage);
